import { Box } from "@mui/material";
import { ReactNode } from "react";
import { listPageSearchFieldMinWidth, listPageToolbarContainerName, narrowListPageToolbarQuery } from "./ListPageToolbar.styles";

interface ListPageToolbarProps {
    viewContent?: ReactNode;
    leftContent?: ReactNode;
    rightContent?: ReactNode;
    savedViewsMenu?: ReactNode;
    // The actions on the selected rows end the row after the view button, which belongs with the column and export buttons
    bulkActions?: ReactNode;
}

function ListPageToolbar(props: ListPageToolbarProps) {
    const { viewContent, leftContent, rightContent, savedViewsMenu, bulkActions } = props;

    return (
        <Box sx={{ containerType: "inline-size", containerName: listPageToolbarContainerName }}>
            {viewContent && <Box sx={{ marginBottom: 1.5 }}>{viewContent}</Box>}
            {/* The filters wrap beside the buttons, so the buttons always share the last filter row, right above the table.
                A narrow toolbar puts the buttons on a row of their own above the search, so they keep their place however
                many filter chips wrap below them. */}
            <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-end", gap: 1, [narrowListPageToolbarQuery]: { justifyContent: "flex-start" } }}>
                <Box
                    data-list-page-toolbar-left
                    sx={{
                        display: "flex",
                        flex: "1 1 0",
                        minWidth: listPageSearchFieldMinWidth,
                        flexWrap: "wrap",
                        alignItems: "stretch",
                        gap: 1,
                        // A narrow toolbar has no room for a column beside the filters, so the filters wrap as rows of the
                        // toolbar itself: the full width search gets a row of its own, with the chips below it
                        [narrowListPageToolbarQuery]: { display: "contents" },
                    }}
                >
                    {leftContent}
                </Box>
                {(rightContent || savedViewsMenu || bulkActions) && (
                    <Box
                        sx={{
                            display: "flex",
                            alignSelf: "flex-end",
                            alignItems: "center",
                            gap: 1,
                            // The left side's children are items of this row on a narrow toolbar, so the order moves the buttons above them.
                            // A flex item is never narrower than its content by default, and the view button's fixed width would keep
                            // this row wider than the toolbar, so the minimum width is lifted to let the view button shrink instead.
                            [narrowListPageToolbarQuery]: { order: -1, flexBasis: "100%", minWidth: 0, justifyContent: "flex-end" },
                        }}
                    >
                        {rightContent}
                        {savedViewsMenu}
                        {bulkActions}
                    </Box>
                )}
            </Box>
        </Box>
    );
}

export default ListPageToolbar;
